// extracted by mini-css-extract-plugin
module.exports = {"Protecting":"Protecting_Protecting__plW6y"};